import { Module } from "vuex";
import { IProfileState } from "@/core/interfaces/profile.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const profileModule: Module<IProfileState, StoreState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default profileModule;
